const riot = require('riot');

riot.tag2('modal-child-notes', '<div class="modal bg-white w472 s-w-full rounded-8 m8" ref="modal"> <div class="f fm flex-between p16"> <div class="bold fs16">子タスクノート一覧 ({opts.note.data.child_note_refs.length})</div> <button class="f fm cursor-pointer" onclick="{openPopupSuggestionNotes}"><span class="mr4">ノートを追加</span><i class="icon-add_circle"></i></button> </div> <div class="max-height-70vh min-height-88 overflow-y-scroll scrollbar-none p16"> <div class="rounded-8 border border-transparent mxn1 mb6 relative" each="{note in notes}"> <div class="hover-board-shadow box-shadow-primary rounded-8 overflow-hidden transition" data-is="item-note" item="{note}" onclick="{onClickItemNote}"></div> <button class="absolute tn4 rn4" onclick="{deleteChildNote}"> <div class="s24 circle bg-white f fh"><span class="icon-close cursor-pointer p8 fs18"></span></div> </button> </div> </div> </div>', 'modal-child-notes,[data-is="modal-child-notes"]{background-color:rgba(0,0,0,0.5)} modal-child-notes input::placeholder,[data-is="modal-child-notes"] input::placeholder{color:rgba(29,40,76,0.2);font-size:13px}', 'class="f fh s-px8" spat-animation="push"', function(opts) {
    this.notes = [];
    this.on('mount', async () => {
      this.fetchNotes();
    });

    this.fetchNotes = async () => {
      const note_refs = this.opts.note.data.child_note_refs || [];
      const promises = note_refs.map(async ref => app.store.doc(ref.path).fetch({cache:false, relation:true}));
      const notes = await Promise.all(promises);

      this.update({notes});
    };

    this.openPopupSuggestionNotes = async (e) => {
      const popup = spat.popup.open('popup-suggestion-notes', {
        element: e.currentTarget,
        closeTarget: e.currentTarget,
        offsetTop: 16,
        align: { x: 'right' },
        position: 'bottom',
        opts: {
          project: this.opts.note.getProject(),
          lockProject: true,
        },
      });

      try {
        const selected_notes = await popup.waitClose();

        if (!selected_notes) return ;

        let child_note_ids = [
          ...this.opts.note.data.child_note_refs.map(ref => ref.id),
          ...selected_notes.map(n => n.id)
        ];

        child_note_ids = Array.from(new Set(child_note_ids));

        await app.api.child(this.opts.note.ref.path).put({
          child_note_ids,
        });

        selected_notes.forEach(async (note) => {
          const parent_title = `[**${this.opts.note.data.title}**](/${this.opts.note.path})`;
          try {
            await app.api.child(note.ref.path).child('messages').post({
              content: `『${parent_title}』に子タスクとして**追加**されました。`,
            });
          }
          catch (e) {
            console.log(e.message);
          }
        });

        await this.opts.note.refresh();
        await this.fetchNotes();
      }
      catch (e) {
        console.log(e.message);
      }
    };

    this.deleteChildNote = async (e) => {
      e.preventDefault();
      e.stopPropagation();

      try {
        let target_note = e.item.note;

        let child_note_ids = this.opts.note.data.child_note_refs.map(ref => ref.id)
          .filter(id => id !== target_note.id);

        await app.api.child(this.opts.note.ref.path).put({
          child_note_ids,
        });

        const parent_title = `[**${this.opts.note.data.title}**](/${this.opts.note.path})`;
        app.api.child(target_note.ref.path).child('messages').post({
          content: `『${parent_title}』の子タスクから**削除**されました。`,
        });

        await this.opts.note.refresh();
        await this.fetchNotes();
      }
      catch (e) {
        console.log(e.message);
      }
    };

    this.onClickItemNote = async (e) => {
      e.preventDefault();
      e.stopPropagation();

      const note = e.item.note;

      if (app.useragent.isMobile) {
        spat.router.push(`/${note.path}`);
        this.close();
      }
      else {
        const modal = spat.modal.open('modal-note', {
          note,
        });
      }
    };
});